import apiClient from './client';
import type {
  FeatureStats,
  FeatureTrends,
  UserSegments,
  FeatureAdoption,
  StatsPeriod,
  TrendsPeriod,
  TrendsGranularity,
} from '../types/featureAnalytics';

const BASE = '/admin/feature-analytics';

export async function getFeatureStats(period: StatsPeriod = 'all'): Promise<FeatureStats> {
  const { data } = await apiClient.get<FeatureStats>(`${BASE}/stats/`, { params: { period } });
  return data;
}

export async function getFeatureTrends(
  period: TrendsPeriod = '30d',
  granularity?: TrendsGranularity,
): Promise<FeatureTrends> {
  const params: Record<string, string> = { period };
  if (granularity) params.granularity = granularity;
  const { data } = await apiClient.get<FeatureTrends>(`${BASE}/trends/`, { params });
  return data;
}

export async function getUserSegments(): Promise<UserSegments> {
  const { data } = await apiClient.get<UserSegments>(`${BASE}/user-segments/`);
  return data;
}

export async function getFeatureAdoption(): Promise<FeatureAdoption> {
  const { data } = await apiClient.get<FeatureAdoption>(`${BASE}/adoption/`);
  return data;
}
